<template>
  <div>
    <v-card>
      <v-card-title primary-title>
        <app-title>Modify Customer {{section}}</app-title>
      </v-card-title>
      <v-card-text>
        <v-container fluid grid-list-sm>
          <v-row class="box"   >
            <v-col cols="12">
              <app-title>Customer {{section}}</app-title>
            </v-col>
            <v-col class="d-flex" cols="8">
              <v-col class="d-flex" cols="12">
                <v-card light>
                  <wysiwyg v-model="myHTML[section]"/>
                </v-card>
              </v-col>
            </v-col>
            <v-col class="d-flex" cols="4">
              <v-row  >
                <v-col cols="12">
                  <app-title>Details to Insert</app-title>
                </v-col>
                <v-col cols="12">
                  <v-card tile>
                    <v-card-title primary-title>Details of Dealer</v-card-title>
                    <v-card-text>
                      <v-col cols="12">
                        <ul>
                          <li>FirstName</li>
                          <li>Surname</li>
                          <li>Email</li>
                        </ul>
                      </v-col>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card tile>
                    <v-card-title primary-title>Details of Customer</v-card-title>
                    <v-card-text>
                      <v-col cols="12">
                        <ul>
                          <li>FirstName</li>
                          <li>Surname</li>
                          <li>Email</li>
                          <li>Company</li>
                        </ul>
                      </v-col>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card tile>
                    <v-card-title primary-title>Details of Employee</v-card-title>
                    <v-card-text>
                      <v-col cols="12">
                        <ul>
                          <li>FirstName</li>
                          <li>Surname</li>
                          <li>Email</li>
                        </ul>
                      </v-col>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveData">Save</v-btn>
        <v-btn color="primary">Undo</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mockHeaders from "@/helpers/mockHeaders.json";
export default {
  components: {},
  data() {
    return {
      myHTML: {
        SMS: ` Please follow this link to complete your Vonex order: {{frontEndUrl}}`,
        Email: `<div id="customerEmail">
                                <p>
                                    Hi {{ customer.customer.firstName}},
                                </p>
                                <p>
                                    Please review the recent order completed with our Authorised Vonex Telecom Channel Partner :<strong>
                                            {{dealer.dealer.dealerFullName}}.
                                        </strong>
                                </p>
                                <p>
                                    You may have been requested to upload documents that are required, please do so by following the link below.
                                </p>
                                <p>
                                    This link will enable you to review this order, confirm the terms and conditions, and upload required documents.
                                </p>
                                <p>
                                    Click this link to complete these actions: <a id="signOnGlassUrl" :href="frontEndUrl" target="_blank">Click to go to Sign On Glass</a>
                                </p>
                                <p>
                                    When completed this order will be sent to the Vonex helpdesk and processing will begin.
                                </p>
                                <p>
                                    We will be in touch with further details of your order.
                                </p>
                                <p>
                                    Regards
                                </p>
                                <p>
                                    <b>Vonex Telecom</b>
                                </p>
                            </div>`,
        OrderReportHeader: mockHeaders.OrderReportHeading,
        OrderReportFrom: mockHeaders.OrderReportFrom
      }
    };
  },
  computed: {
    section: function() {
      return this.$route.params.section;
    }
  },

  mounted() {
    //  this.setText(this.$route.params.section);
  },
  methods: {
    saveData() {
      alert(this.myHTML[this.section]);
    }
  }
};
</script>
<style scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
</style>